import { default as JSCookies, type CookieAttributes } from 'js-cookie';

import { isLucidMarketingDomain } from '../validators/regex';

const getCookie = (name: string) => {
  const cookie = JSCookies.get(name) || undefined;

  return cookie;
};

export const setCookie = (name: string, value: string, options = {} as CookieAttributes) => {
  const cookie = JSCookies.set(name, value, options);

  return cookie;
};

// This method is not SSR safe, and should only be run in client-side code.
export const initialLandingPage = () => {
  const { origin, pathname } = window.location;
  const url = `${origin}${pathname}`;
  const cookie = getCookie('initialLandingPage');
  let sessionInitialLandingPage = '';

  if (!window.sessionStorage.initialLandingPage && !cookie) {
    setCookie('initialLandingPage', url);
    return (window.sessionStorage.initialLandingPage = url);
  }

  if (window.sessionStorage.initialLandingPage) {
    sessionInitialLandingPage = url;
  }

  if (url.match(isLucidMarketingDomain) && cookie && !sessionInitialLandingPage) {
    setCookie('initialLandingPage', url);
    return (window.sessionStorage.initialLandingPage = url);
  }
};

export { JSCookies as Cookies };
export default getCookie;
